const MODEL_CONFIG = "modelConfig";

const getModelConfig = (key) => {
    const item = localStorage.getItem(key);

    if (!item) return null;

    try {
        return JSON.parse(item);
    } catch (error) {
        // console.error("parse error:", error);
        return null;
    }
};

const modelConfigData = {
    "modelUrl": [
        {
            "name": "drop#01",
            "items": [
                {
                    name: "BLACK",
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Black_coordinates.png?v=1738738830"
                },
                {
                    name: "WHITE",
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_White_coordinates.png?v=1726650786"
                },
                {
                    name: "YELLOW",
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Yellow_coordinates.png?v=1726650785"
                },
                {
                    name: "GREEN",
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Green_coordinates.png?v=1726650785"
                },
                {
                    name: "ORANGE",
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Orange_coordinates.png?v=1726650785"
                },
                {
                    name: "PINK",
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_1_-_Pink_coordinates.png?v=1726650786"
                },
            ]
        },
        {
            "name": "drop#02",
            "items": [
                {
                    name: "BLACK",
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_2_-_Black_Coordinates.png?v=1738738845"
                },
                {
                    name: "WHITE",
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_2_-_White_Coordinates.png?v=1738738845"
                },
                {
                    name: "PINK",
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_2_-_Pink_Coordinates.png?v=1738738845"
                },
            ]
        },
        {
            "name": "drop#03",
            "items": [
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_Black_Coordinates.png?v=1738738857",
                    name: "BLACK"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_White_Coordinates.png?v=1738738856",
                    name: "WHITE"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_Pink_Coordinates.png?v=1738738856",
                    name: "PINK"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_Orange_Coordinates.png?v=1738738856",
                    name: "ORANGE"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Drop_3_-_Blue_Coordinates.png?v=1738738857",
                    name: "LIGHT BLUE"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Full_view_430x.png?v=1733155760",
                    name: "DARK BLUE"
                }
            ]
        },
        {
            "name": "shirt",
            "items": [
                {
                    url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/black_shirt_blue_bottle.png?v=1778576310",
                    name: "shirt_BLACK_bottle_2300ml"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/black_shirt_black_bottle.png?v=1778576310",
                    name: "shirt_BLACK_bottle_730ml"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/white_shirt_blue_bottle.png?v=1778576310",
                    name: "shirt_WHITE_bottle_2300ml"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0809/2074/0152/files/white_shirt_black_bottle.png?v=1778576310",
                    name: "shirt_WHITE_bottle_730ml"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/White_with_Black.jpg?v=1780905702",
                    name: "shirt_WHITE_print_BLACK"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/White_with_Blue.jpg?v=1780905702",
                    name: "shirt_WHITE_print_BLUE"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/White_with_Green.jpg?v=1780905702",
                    name: "shirt_WHITE_print_GREEN"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/White_with_Pink.jpg?v=1780905702",
                    name: "shirt_WHITE_print_PINK"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/White_with_White.jpg?v=1780905702",
                    name: "shirt_WHITE_print_WHITE"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Black_with_Black.jpg?v=1780905702",
                    name: "shirt_BLACK_print_BLACK"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Black_with_Blue.jpg?v=1780905702",
                    name: "shirt_BLACK_print_BLUE"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Black_with_Green.jpg?v=1780905702",
                    name: "shirt_BLACK_print_GREEN"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Black_with_Pink.jpg?v=1780905702",
                    name: "shirt_BLACK_print_PINK"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Black_with_White.jpg?v=1780905702",
                    name: "shirt_BLACK_print_WHITE"
                },
                {
                    url: "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/Black_with_Yellow.jpg?v=1780905703",
                    name: "shirt_BLACK_print_YELLOW"
                },
            ]
        }
    ],
    "colorConfig": [
        {
            "name": "drop#01",
            "options": [
                {
                    name: "BLACK",                    
                    hex: "#000000",
                    formHex: "#000000",
                    value: "BLACK: #000000"
                },
                {
                    name: "WHITE",                    
                    hex: "#FFFFFF",
                    formHex: "#FFFFFF",
                    value: "WHITE: #F2F2F2"
                },
                {
                    name: "YELLOW",                    
                    hex: "#d9f107",
                    formHex: "#e9e824",
                    value: "YELLOW: #e9e824"
                },
                {
                    name: "GREEN",                    
                    hex: "#42d16d",
                    formHex: "#02a449",
                    value: "GREEN: #02a449"
                },
                {
                    name: "ORANGE",                    
                    hex: "#ff9500",
                    formHex: "#df7926",
                    value: "ORANGE: #df7926"
                },
                {
                    name: "PINK",                    
                    hex: "#d899b7",
                    formHex: "#f098bf",
                    value: "PINK: #f098bf"
                }
            ]
        },
        {
            "name": "drop#02",
            "options": [
                {
                    "hex": "#000000",
                    "formHex": "#000000",
                    "name": "BLACK",
                    "value": "BLACK: #000000"
                },
                {
                    "hex": "#FFFFFF",
                    "formHex": "#FFFFFF",
                    "name": "WHITE",
                    "value": "WHITE: #F2F2F2"
                },
                {
                    "hex": "#da82b6",
                    "formHex": "#f098bf",
                    "name": "PINK",
                    "value": "PINK: #f098bf"
                }
            ]
        },
        {
            "name": "drop#03",
            "options": [
                {
                    name: "BLACK",
                    hex: "#000000",
                    formHex: "#000000",
                    value: "BLACK: #000000"
                },
                {
                    name: "WHITE",
                    hex: "#FFFFFF",
                    formHex: "#FFFFFF",
                    value: "WHITE: #F2F2F2"
                },
                {
                    name: "ORANGE",
                    hex: "#ff9500",
                    formHex: "#df7926",
                    value: "ORANGE: #df7926"
                },
                {
                    name: "PINK",
                    hex: "#d899b7",
                    formHex: "#f098bf",
                    value: "PINK: #f098bf"
                },
                {
                    name: "LIGHT BLUE",
                    hex: "#86c5ee",
                    formHex: "#72b9e2",
                    value: "LIGHT BLUE: #72b9e2"
                },
            ]
        }
    ],
    "badgeColorConfig": [
        {
            "name": "drop#01",
            "info": "Your ALTAIR ADVENTURE HOODIE comes with two interchangeable badges, one in black and one in white colour.",
            "options": [
                {
                    "name": "BLACK",
                    "formHex": "#000000",
                    "hex": "#000000",
                    "value": "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/hoodie_1_texture_black.png"
                },
                {
                    "name": "WHITE",
                    "formHex": "#FFFFFF",
                    "hex": "#FFFFFF",
                    "value": "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/hoodie_1_texture_white.png"
                }
            ]
        },
        {
            "name": "drop#02",
            "info": "Your VEGA VOYAGER HOODIE comes with two interchangeable badges, one in pink and one in black colour.",
            "options": [
                {
                    "name": "PINK",
                    "formHex": "#fccce4",
                    "hex": "#fccce4",
                    "value": "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/hoodie_2_texture_pink_fix.png"
                },
                {
                    "name": "BLACK",
                    "formHex": "#000000",
                    "hex": "#000000",
                    "value": "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/hoodie_2_texture_black_fix.png"
                },
            ]
        },
        {
            "name": "drop#03",
            "info": "Your DENEB EXPLORER HOODIE comes with two interchangeable badges, one in blue and one in black colour.",
            "options": [
                {
                    "name": "BLUE",
                    "formHex": "#2360b2",
                    "hex": "#2360b2",
                    "value": "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/hoodie_3_texture_blue.png"
                },
                {
                    "name": "BLACK",
                    "formHex": "#000000",
                    "hex": "#000000",
                    "value": "https://cdn.shopify.com/s/files/1/0619/0776/3356/files/hoodie_3_texture_black.png"
                },
            ]
        }
    ],
    "modelConfig": {
        "v20231229": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_3",
                "scale": 0.15,
                "position": [
                    0.0008906269826619018,
                    1.6234153046028548,
                    -0.06443538718810547
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759057,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth",
                "scale": [
                    0.05,
                    0.15,
                    0.08
                ],
                "position": [
                    0.2704990301602291,
                    1.269839442338963,
                    0.00693749080169649
                ],
                "rotation": [
                    -1.058397369020995,
                    1.1439996625577835,
                    1.0458057922682629
                ]
            },
            "modelConfigs": {}
        },
        "v20240219": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_3",
                "scale": 0.15,
                "position": [
                    0.0008906269826619018,
                    1.6234153046028548,
                    -0.06443538718810547
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759057,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_7",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.3111340096533122,
                    1.2455296765274964,
                    -0.014395258032479848
                ],
                "rotation": [
                    -0.8821751202173895,
                    1.2714148438452249,
                    0.8182033151514024
                ]
            },
            "modelConfigs": {}
        },
        "v20240615": {
            "logoConfigs": {
                "mesh": "Cloth",
                "scale": 5,
                "position": [
                    30.88788405384658,
                    127.8589932606541,
                    -0.31124338351055225
                ],
                "rotation": [
                    -1.058397369020995,
                    1.1439996625577835,
                    1.0458057922682629
                ]
            },
            "textConfigs": {
                "mesh": "Cloth",
                "scale": [
                    5,
                    15,
                    8
                ],
                "position": [
                    30.88788405384658,
                    127.8589932606541,
                    -0.31124338351055225
                ],
                "rotation": [
                    -1.058397369020995,
                    1.1439996625577835,
                    1.0458057922682629
                ]
            },
            "modelConfigs": {}
        },
        "v20240621": {
            "logoConfigs": {
                "mesh": "Cloth",
                "scale": 0.15,
                "position": [
                    -0.003943595244112582,
                    1.5790211854423526,
                    -0.0896267341827224
                ],
                "rotation": [
                    -2.303674817682947,
                    0.009541417999693769,
                    3.1515389682867188
                ]
            },
            "textConfigs": {
                "mesh": "Cloth",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.2944914628150091,
                    1.27822308287163,
                    -0.008433700590125694
                ],
                "rotation": [
                    -1.058397369020995,
                    1.1439996625577835,
                    1.0458057922682629
                ]
            },
            "modelConfigs": {}
        },
        "v20240702": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_3",
                "scale": 0.15,
                "position": [
                    0.0008906269826619018,
                    1.6234153046028548,
                    -0.06443538718810547
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759057,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_15",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.2999302719485846,
                    1.2801795262232352,
                    -0.007564079640593089
                ],
                "rotation": [
                    -1.0781351014090441,
                    1.2112646514770113,
                    1.0404184603132725
                ]
            },
            "modelConfigs": {}
        },
        "v20240715": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_3",
                "scale": 0.15,
                "position": [
                    0.0008906269826619018,
                    1.6234153046028548,
                    -0.06443538718810547
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759057,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_1",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.2999302719485846,
                    1.2801795262232352,
                    -0.007564079640593118
                ],
                "rotation": [
                    -1.1091134156413358,
                    1.2004036862974172,
                    1.0352228691095828
                ]
            },
            "modelConfigs": {}
        },
        "v20240731": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_3",
                "scale": 0.15,
                "position": [
                    0.0008906269826619018,
                    1.6234153046028548,
                    -0.06443538718810547
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759057,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_1",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.2999302719485846,
                    1.2801795262232352,
                    -0.007564079640593118
                ],
                "rotation": [
                    -1.1091134156413358,
                    1.2004036862974172,
                    1.0352228691095828
                ]
            },
            "modelConfigs": {}
        },
        "v20240910": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_1",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    0.00515372552571838,
                    1.6454093788365165,
                    -0.12533671659709
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759057,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_1",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.2999302719485846,
                    1.2801795262232352,
                    -0.007564079640593118
                ],
                "rotation": [
                    -1.0613053562801797,
                    1.217238869921091,
                    1.0431030582205045
                ]
            },
            "modelConfigs": {},
            "badgeConfigs": {
                "mesh": [
                  "Cloth_mesh_4"
                ]
            }
        },
        "v20241128": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_50",
                "scale": [
                    0.03,
                    0.008,
                    0.03
                ],
                "position": [
                    0.0005074181150786228,
                    1.6541753332544455,
                    -0.203954495446492
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759057,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_12",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.3003528889850636,
                    1.3352531569042845,
                    0.004809468592406737
                ],
                "rotation": [
                    -1.096737319614782,
                    1.1323478460252556,
                    1.0529091635131067
                ]
            },
            "modelConfigs": {}
        },
        "v20241203": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_50",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    -0.0034417969459882014,
                    1.6177150150660198,
                    -0.16485415345341342
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759052,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_12",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.3119957971656892,
                    1.2564746145685282,
                    -0.015290339928822486
                ],
                "rotation": [
                    -0.9173696384486556,
                    1.1792211038714957,
                    0.8863049125429348
                ]
            },
            "modelConfigs": {}
        },
        "v20241206": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_1",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    -0.0034417969459882014,
                    1.6177150150660198,
                    -0.16485415345341342
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759052,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_1",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.311426283586792,
                    1.2609615002846946,
                    -0.018881823184909864
                ],
                "rotation": [
                    -0.8890605854134696,
                    1.1886121477636962,
                    0.8932863607611663
                ]
            },
            "modelConfigs": {
                "Cloth_mesh" : "#eaa8c7",
                "Cloth_mesh_1" : "#eaa8c7",
                "Cloth_mesh_3" : "#eaa8c7",
                "Cloth_mesh_4" : "#eaa8c7",
                "Cloth_mesh_5" : "#eaa8c7",
                "Cloth_mesh_6" : "#eaa8c7",
                "Cloth_mesh_7" : "#eaa8c7",
                "Cloth_mesh_8" : "#eaa8c7",
            }
        },
        "v20250117": {
            "logoConfigs": {
                "mesh": "Cloth_mesh",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    -0.003980288350001359,
                    1.6550662728759697,
                    -0.11396017905650863
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759052,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.30790963073386884,
                    1.2640018987630395,
                    -0.014166258047661863
                ],
                "rotation": [
                    -0.9269970532688953,
                    1.3124920884942826,
                    0.8729544926260977
                ]
            },
            "modelConfigs": {},
            "badgeConfigs":{
                "mesh": [
                    "Cloth_mesh_2"
                ]
            }
        },
        "v20250218": {
            "logoConfigs": {
                "mesh": "Cloth_mesh001_1",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    -0.0020023675014856548,
                    1.6211750760595307,
                    -0.18968721774459454
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759052,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh001_1",
                "scale": [
                    0.04,
                    0.14,
                    0.01
                ],
                "position": [
                    0.30872058573831473,
                    1.265512586389679,
                    -0.01934862700437598
                ],
                "rotation": [
                    -0.8890605854134696,
                    1.1886121477636962,
                    0.8932863607611663
                ]
            },
            "modelConfigs": {
                "Cloth_mesh001": "#fccce4",
                "Cloth_mesh001_1": "#ffdbed",
                "Cloth_mesh001_3": "#fccce4",
                "Cloth_mesh001_4": "#fccce4",
                "Cloth_mesh001_5": "#fccce4",
                "Cloth_mesh001_6": "#fccce4",
                "Cloth_mesh001_7": "#fccce4",
                "Cloth_mesh001_8": "#fccce4",
            },
            "badgeConfigs":{
                "mesh": [
                    "Cloth_mesh001_2"
                ]
            }
        },        
        "v20250219": {
            "logoConfigs": {
                "mesh": "Cloth084",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    -0.0032967075708975457,
                    1.6597547794166263,
                    -0.12247488023050412
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759052,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth071",
                "scale": [
                    0.04,
                    0.14,
                    0.01
                ],
                "position": [
                    0.3100478680377345,
                    1.2574149056800417,
                    -0.011881232129547944
                ],
                "rotation": [
                    -0.8549030247897498,
                    1.2956302657348573,
                    0.810988036449245
                ]
            },
            "modelConfigs": {
                "Button_275527": "#7b91b5",
            },
            "badgeConfigs":{
                "mesh": [
                    "Cloth125",
                    "Cloth126",
                    "Cloth127",
                    "Cloth128",
                    "Cloth129",
                    "Cloth130",
                    "Cloth131"
                ]
            }
        },
        "v20250303": {
            "logoConfigs": {
                "mesh": "Cloth001",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    0.00515372552571838,
                    1.6454093788365163,
                    -0.12533671659709
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759057,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth001",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.2999302719485846,
                    1.2801795262232352,
                    -0.007564079640593118
                ],
                "rotation": [
                    -1.1091134156413358,
                    1.2004036862974172,
                    1.0352228691095828
                ]
            },
            "modelConfigs": {},
            "badgeConfigs":{
                "mesh": [
                    "Cloth025"
                ]
            }
        },
        "v20250721": {
            "logoConfigs": {
                "mesh": "Cloth",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    -0.001826897456702507,
                    1.6183821997625278,
                    -0.19617517239290377
                ],
                "rotation": [
                    -2.7950257908860463,
                    0.06574330974759052,
                    3.175421655116186
                ]
            },
            "textConfigs": {
                "mesh": "Cloth",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.31039035435648427,
                    1.257696967555358,
                    -0.019731202908987056
                ],
                "rotation": [
                    -0.8879104334979664,
                    1.3213776363521113,
                    0.878694193273317
                ]
            },
            "modelConfigs": {
                "Cloth": "#fccce4",
            },
            "badgeConfigs":{
                "mesh": [
                    "Cloth"
                ]
            }
        },
        "v20260406": {
            "logoConfigs": {
                "mesh": "Object_2001",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    -0.0003800960244927623,
                    1.617952833423217,
                    -0.11149337606367807
                ],
                "rotation": [
                    -2.7705955908049313,
                    0.06443289367075626,
                    3.17666905626934
                ]
            },
            "textConfigs": {
                "mesh": "Object_2001",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    0.09880424134590353,
                    1.3751459003672395,
                    0.10065470353093414
                ],
                "rotation": [
                    3.1392527950623688,
                    2.7978911091785714,
                    -0.04498202290921516
                ]
            },
            "modelConfigs": {
                "Object_2001": "#111111"
            },
            "badgeConfigs": {}
        },
        /* 16: SOL TRAVELLER SHIRT — White variant */
        "v20260429": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_3",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    -0.0020231486477602367,
                    1.4419520287464003,
                    0.09181148864572138
                ],
                "rotation": [
                    3.0219900581544055,
                    3.145725731429474,
                    -3.147102890537802
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_4",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    -0.0045925680020301755,
                    1.5285313793728503,
                    -0.12484797303588127
                ],
                "rotation": [
                    -2.966625963422504,
                    0.07628258998004313,
                    3.168513429225737
                ]
            },
            "modelConfigs": {
                "Cloth_mesh":   "#F5F5F5",
                "Cloth_mesh_1": "#F5F5F5",
                "Cloth_mesh_2": "#F5F5F5",
                "Cloth_mesh_3": "#F5F5F5",
                "Cloth_mesh_4": "#F5F5F5"
            },
            "badgeConfigs": {}
        },
        /* 17: SOL TRAVELLER SHIRT — Black variant */
        "v20260430": {
            "logoConfigs": {
                "mesh": "Cloth_mesh_4",
                "scale": [
                    0.05,
                    0.01,
                    0.05
                ],
                "position": [
                    -0.0003800960244927623,
                    1.617952833423217,
                    -0.11149337606367807
                ],
                "rotation": [
                    -2.7705955908049313,
                    0.06443289367075626,
                    3.17666905626934
                ]
            },
            "textConfigs": {
                "mesh": "Cloth_mesh_3",
                "scale": [
                    0.05,
                    0.15,
                    0.02
                ],
                "position": [
                    -0.0045925680020301755,
                    1.5285313793728503,
                    -0.12484797303588127
                ],
                "rotation": [
                    3.1392527950623688,
                    2.7978911091785714,
                    -0.04498202290921516
                ]
            },
            "modelConfigs": {
                "Cloth_mesh":   "#2b2b2b",
                "Cloth_mesh_1": "#2b2b2b",
                "Cloth_mesh_2": "#2b2b2b",
                "Cloth_mesh_3": "#2b2b2b",
                "Cloth_mesh_4": "#2b2b2b"
            },
            "badgeConfigs": {}
        },
    },
    "shirtConfig": {
        "productId": "10492735652152",
        "variantMeshColors": {
            "BLACK": "#2b2b2b",
            "WHITE": "#F5F5F5"
        },
        "coordColors": {
            "BLACK": [
                { "name": "BLACK",  "hex": "#000000", "formHex": "#000000", "value": "BLACK: #000000" },
                { "name": "WHITE",  "hex": "#FFFFFF", "formHex": "#FFFFFF", "value": "WHITE: #FFFFFF" },
                { "name": "GREEN",  "hex": "#42d16d", "formHex": "#02a449", "value": "GREEN: #02a449" },
                { "name": "YELLOW", "hex": "#d9f107", "formHex": "#e9e824", "value": "YELLOW: #e9e824" },
                { "name": "PINK",   "hex": "#d899b7", "formHex": "#f098bf", "value": "PINK: #f098bf" },
                { "name": "BLUE",   "hex": "#86c5ee", "formHex": "#72b9e2", "value": "BLUE: #72b9e2" }
            ],
            "WHITE": [
                { "name": "BLACK",  "hex": "#000000", "formHex": "#000000", "value": "BLACK: #000000" },
                { "name": "WHITE",  "hex": "#FFFFFF", "formHex": "#FFFFFF", "value": "WHITE: #FFFFFF" },
                { "name": "GREEN",  "hex": "#42d16d", "formHex": "#02a449", "value": "GREEN: #02a449" },
                { "name": "PINK",   "hex": "#d899b7", "formHex": "#f098bf", "value": "PINK: #f098bf" },
                { "name": "BLUE",   "hex": "#86c5ee", "formHex": "#72b9e2", "value": "BLUE: #72b9e2" }
            ]
        }
    }
};


const setModelConfigData = (modelConfigData) => {
    localStorage.setItem(MODEL_CONFIG, JSON.stringify(modelConfigData));
}

setModelConfigData(modelConfigData);